import {msi} from '../../styles';

export const MODAL_OFFSET = msi(20);

export const MODAL_PADDING = msi(20);

export const MODAL_OVERLAY_Z_INDEX = 98;

export const CLOSE_TIMEOUT_MS = 200;

export const MODAL_CLASS_NAMES = {
  body: 'body',
  closeButton: 'close-button',
  content: 'modal-content',
  footerContainer: 'modal-footer',
  header: 'header',
  headerWrapper: 'header-wrapper',
  modal: 'Modal',
  noScroll: 'modal-no-scroll',
  overlay: 'modal-overlay',
  scrollContainer: 'scroll-container',
};
